import React, { useMemo } from "react"
import { useSearchParams } from "react-router-dom"
import { MobileRecordProvider } from "../../contexts/mobileRecordContext"
import ChildRecords from "./mobileRecordDisplays/childRecords"

const TabRecords = () => {
  let [searchParams, setSearchParams] = useSearchParams()
  const currentTabName = useMemo(() => searchParams.get("tab"), [searchParams])

  return (
    <>{!!currentTabName && (
      <div className='flex flex-row flex-1 bg-gray-100'>
        <MobileRecordProvider>
          <ChildRecords map={[currentTabName]} />
        </MobileRecordProvider>
      </div>
    )} </>
  )
}

export default TabRecords
